import React from "react";

export default function Map({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18.334"
      viewBox="0 0 20 18.334"
      className={color}
    >
      <g id="treasure-map-21" transform="translate(0 -0.999)">
        <g id="Group_330" dataname="Group 330" transform="translate(0 0.999)">
          <path
            id="Path_134"
            dataname="Path 134"
            d="M19.679,1.177a.83.83,0,0,0-.715-.152L12.533,2.633,7.763,1.042A.821.821,0,0,0,7.3,1.025L.631,2.692A.833.833,0,0,0,0,3.5v15a.833.833,0,0,0,1.036.808L7.467,17.7l4.77,1.59a.836.836,0,0,0,.466.017l6.667-1.667A.831.831,0,0,0,20,16.833v-15A.832.832,0,0,0,19.679,1.177ZM5.833,11h-2.5V9.333h2.5ZM10,11H7.5V9.333H10Zm7.012.833-1.178,1.178-1.667-1.667L12.5,13.012l-1.178-1.178,1.667-1.667L11.322,8.5,12.5,7.322l1.667,1.667,1.667-1.667L17.012,8.5l-1.667,1.667Z"
            transform="translate(0 -0.999)"
          />
        </g>
      </g>
    </svg>
  );
}
